import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pages/SchoolsPage.tsx");
